import React, { Fragment } from 'react';
import If from 'src/components/Shared/If/If';
import 'src/components/Buy/BuyFlow/ExpandedFundList/ExpandedFund.module.scss';

const DeliveryMethodFundNoteTip: React.FC<{ allFunds?: boolean }> = ({
  allFunds = false,
}) => (
  <Fragment>
    <If test={!allFunds}>
      <span className="exclude">
        Due to recent activity on this fund account or agreement redemptions via
        check are blocked. Please{' '}
        <a
          className="contact-link"
          href="https://www.troweprice.com/personal-investing/help/contact/index.html"
          rel="noreferrer"
          target="_blank"
        >
          contact us
        </a>{' '}
        for more information or select a different method for distribution.{' '}
      </span>
    </If>
  </Fragment>
);

export default DeliveryMethodFundNoteTip;
